import { Injectable } from '@angular/core';

import { PaymentType } from '@spartacus/cart/base/root';
import { CheckoutPaymentTypeService } from '@spartacus/checkout/b2b/core';
import { Query } from '@spartacus/core';
import { switchMap } from 'rxjs';

@Injectable()
export class DpCheckoutPaymentTypeService extends CheckoutPaymentTypeService {
  protected paymentTypesQuery: Query<PaymentType[]> = this.queryService.create(
    () => this.userIdService.takeUserId(true).pipe(switchMap(() => this.paymentTypeConnector.getPaymentTypes())),
    {
      reloadOn: this.getCheckoutPaymentTypesQueryReloadEvents(),
      resetOn: this.getCheckoutPaymentTypesQueryResetEvents()
    }
  );
}
